import { render } from "./VerificationView.vue?vue&type=template&id=79c1c10e"
import script from "./VerificationView.vue?vue&type=script&lang=js"
export * from "./VerificationView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__